import React from 'react';
import {SimpleForm, SelectInput, Edit, TextInput, NumberInput, minValue, maxValue, SaveButton, Toolbar} from "react-admin";
import SimpleHeader from "../../framework/util/forms/SimpleHeader";
import PressPalletIcon from "../presspalletbuilder/PressPalletIcon";

export const settingsId = 'palletTracker';
export const settingsTitle = 'Pallet Tracker';
export const settingsDesc = 'Settings related to the pallet tracking stations';

const PostEditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);

const TimePeriodChooser = ({source, label, period, min, max}) => {

    const choices = [];
    for (var i = min; i <= max; i++) {
        const name = i + ' ' + period + (i != 1 ? 's' : '');
        choices.push({id: i, name: name})
    }
    console.log(choices);
    return (<SelectInput source={source} choices={choices}/>);
}

const SystemSettingsEditPalletTracker = (props) => {

    const {source, label, period, min, max} = props;

    return (
        <div>
            <SimpleHeader title={settingsTitle} description={settingsDesc} icon={(<PressPalletIcon/>)}/>
            <Edit {...props}>
                <SimpleForm toolbar={<PostEditToolbar />}>
                    <TextInput source="settingsTitle" value={settingsTitle} disabled={true}/>
                    <TextInput source="settingsDesc" value={settingsDesc} disabled={true}/>
                    <NumberInput variant="outlined" source="retainDays"  min={0} max={365} validate={[minValue(0), maxValue(365)]}/>
                    <NumberInput variant="outlined" source="retainHours"  min={0} max={24} validate={[minValue(0), maxValue(24)]}/>
                </SimpleForm>
            </Edit>
        </div>
    );


}

export default SystemSettingsEditPalletTracker;
